import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography, Grid, Box } from '@mui/material';
import Information from '../../PracticesPage/Components/Information';
import { CenteredFlexBox } from '../../../Components/FlexBox';
import EmailContacts from './EmailContacts';

const ClientInfoWidget = function ClientInfoWidget({
  selectedCustomer,
  contactIndex = 0,
  selectedEmailAddress,
  changePhoneOrMail,
  handleChangeSelectedEmailAddress,
}) {
  const intl = useIntl();
  const {
    fiscalCode,
    vatCode,
    contacts,
    distanceKm = null,
  } = selectedCustomer || {};

  const addressContact =
    contacts[contactIndex] !== undefined
      ? contacts[contactIndex]?.contactAddresses?.find(
          ({ addressTypeId }) => addressTypeId === 1
        )
      : null;
  const infos = [
    {
      label: intl.messages.FISCALCODE,
      value: fiscalCode,
    },
    {
      label: intl.messages.VATCODE,
      value: vatCode,
    },
    {
      label: intl.messages.COMPANYCODE,
      value: selectedCustomer?.companyCode,
    },
    {
      label: intl.messages.CITY_NAME,
      value: addressContact?.city,
    },
    {
      label: intl.messages.DISTANCE_KM_FROM_BRANCH,
      value: distanceKm?.toFixed(2),
    },
    {
      label: intl.messages.RESIDENCE_ADDRESS,
      value: addressContact?.address,
    },
    {
      label: intl.messages.OCCUPATION,
      value: contacts[contactIndex]?.occupation,
    },
    {
      label: intl.messages.OCCUPATION_ENVIRONMENT,
      value: contacts[contactIndex]?.occupationEnvironment,
    },
    {
      label: intl.messages.EMPLOYER,
      value: contacts[contactIndex]?.employeer,
    },
    {
      label: intl.messages.OFFER,
      value: selectedCustomer?.tag,
    },
  ];
  return (
    <Box
      sx={{
        overflow: "auto",

        '&::-webkit-scrollbar-track': {
          backgroundColor: 'primary.main',
        },

        '&::-webkit-scrollbar': {
          backgroundColor: 'primary.main',
          marginRight: '.5px',
        },

        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'white.main',
        },

        flex: '1 1 70%'
      }}>
      <Box sx={{
        p: "8px 24px"
      }}>
        <Grid container spacing={1}>
          <Grid size={{ md: 12, sm: 12, xs: 12 }}>
            <EmailContacts
              selectedEmailAddress={selectedEmailAddress}
              changePhoneOrMail={changePhoneOrMail}
              contact={selectedCustomer?.contacts[contactIndex]}
              handleChangeSelectedEmailAddress={
                handleChangeSelectedEmailAddress
              }
            />
          </Grid>
          {infos
            ?.filter((x) => x?.value)
            .map((info) => (
              <Grid
                key={info.label}
                size={{
                  md:
                    info.label === intl.messages.RESIDENCE_ADDRESS ||
                    info.label === intl.messages.EMAIL_ADDRESS ||
                    info.label === intl.messages.EMPLOYER
                      ? 12
                      : 6,
                  sm: 12,
                  xs: 12,
                }}
              >
                <Information
                  styles={{
                    root: {
                      gap: '0px',
                    },

                    valueStyle: { color: '#fff' },
                  }}
                  caption={
                    <CenteredFlexBox>
                      <Typography
                        noWrap
                        variant="caption"
                        sx={{ color: '#fff', fontSize: '14px' }}
                      >
                        {info.label}
                      </Typography>
                    </CenteredFlexBox>
                  }
                  value={info.value}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </Box>
  );
};

ClientInfoWidget.propTypes = {
  selectedCustomer: PropTypes.object.isRequired,
  selectedEmailAddress: PropTypes.string,
  handleChangeSelectedEmail: PropTypes.func.isRequired,
  handleAddNewEmailAddress: PropTypes.func.isRequired,
  handleChangeContactStatus: PropTypes.func.isRequired,
  emailAddresses: PropTypes.array,
  isLead: PropTypes.bool,
  valueTypesArray: PropTypes.array,
};

export default ClientInfoWidget;
